export enum PartnerType {
  DENTIST = 'DENTIST',
  TECH = 'TECH',
  COURIER = 'COURIER',
  SUPPLIER = 'SUPPLIER'
}

export interface Address {
  street?: string;
  city?: string;
  state?: string;
  zip?: string;
}

export interface BankAccount {
  name?: string;
  number?: string;
}

export interface Contact {
  id?: number;
  name?: string;
  phoneNumber?: string;
  email?: string;
  address?: Address;
}

export interface Partner {
  id?: number;
  contact?: Contact;
  type?: PartnerType;
  isTenant?: boolean;
  faxNo?: string;
  bankAccounts?: BankAccount[];
  logoAttachment?: {
    id?: string;
    fileName?: string;
    extension?: string;
    url?: string;
  };
}

// Query params for GET /v1/admin/partners. isTenant is tri-state: true = tenants only,
// false = non-tenants only, omitted = no tenancy filter.
export interface PartnersQueryParams {
  type?: string;
  page?: number;
  size?: number;
  sort?: string[];
  searchTerm?: string;
  isTenant?: boolean;
}

export interface CreatePartnerRequest {
  contact: {
    name: string;
    phoneNumber: string;
    email: string;
    address: {
      street: string;
      city: string;
      state: string;
      zip: string;
    };
  };
  type: PartnerType;
  faxNo?: string;
  bankAccounts?: BankAccount[];
  logoAttachment?: {
    id: string;
    fileName: string;
  };
}

export interface UpdatePartnerRequest {
  contact: {
    name: string;
    phoneNumber: string;
    email: string;
    address: {
      street: string;
      city: string;
      state: string;
      zip: string;
    };
  };
  type: PartnerType;
  faxNo?: string;
  bankAccounts?: BankAccount[];
  logoAttachment?: {
    id: string;
    fileName: string;
  };
}
